<script setup>
import { h, onMounted, reactive, ref, unref } from "vue";
import { ReloadOutlined, SearchOutlined } from "@ant-design/icons-vue";
import { deleteRequest, getRequest } from "@/utils/request.js";

const formRef = ref();
const searchFormModel = ref({});
const datasource = ref([]);
const loading = ref(false);

const columns = [
  {
    key: "realName",
    dataIndex: "realName",
    title: "收藏人",
    width: "30%",
  },
  {
    key: "targetName",
    dataIndex: "targetName",
    title: "被收藏",
    width: "30%",
  },
  {
    key: "createTime",
    dataIndex: "createTime",
    title: "收藏时间",
    width: "30%",
  },
  {
    key: "action",
    dataIndex: "action",
    title: "操作",
    width: "300px",
  },
];

const pagination = reactive({
  current: 1,
  pageSize: 10,
  pageSizeOptions: ["10", "50", "100"],
  showTotal: (total, range) => {
    return range[0] + "-" + range[1] + " 共" + total + "条";
  },
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
});

const loadData = () => {
  loading.value = true;

  const { current, pageSize } = unref(pagination);
  const requestBody = Object.assign({}, unref(searchFormModel), {
    pageNo: current,
    pageSize,
  });

  getRequest("/favorite", requestBody)
    .then((response) => {
      if (response.success) {
        pagination.total = response.data.total;
        datasource.value = response.data.records;
      }
    })
    .finally(() => {
      loading.value = false;
    });
};

const tableChange = ({ current, pageSize }) => {
  pagination.current = current;
  pagination.pageSize = pageSize;
  loadData();
};

const resetForm = () => {
  formRef.value.resetFields();
  loadData();
};

const handleRemove = (record) => {
  deleteRequest(`/favorite/${record.id}`).then((response) => {
    if (response.success) {
      loadData();
    }
  });
};

onMounted(() => {
  loadData();
});
</script>

<template>
  <div>
    <a-card>
      <a-form
        ref="formRef"
        layout="inline"
        :labelCol="{ span: 8, offset: 1 }"
        :model="searchFormModel"
        @keydown.enter="loadData"
      >
        <a-row :gutter="[10, 10]" style="width: 100%">
          <a-col :span="6">
            <a-form-item label="公司/个人名称" name="name">
              <a-input
                v-model:value.trim="searchFormModel.name"
                placeholder="请输入公司/个人名称"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="统一社会信用代码/身份证号" name="code">
              <a-input
                v-model:value.trim="searchFormModel.code"
                placeholder="请输入统一社会信用代码/身份证号"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-button
              type="primary"
              style="margin-left: 18px"
              :icon="h(SearchOutlined)"
              @click="loadData"
              @keydown.enter="loadData"
            >
              查询
            </a-button>
            <a-button
              style="margin-left: 18px"
              :icon="h(ReloadOutlined)"
              @click="resetForm"
              >重置
            </a-button>
          </a-col>
        </a-row>
      </a-form>
    </a-card>

    <a-card style="margin-top: 10px">
      <a-table
        row-key="id"
        :loading="loading"
        :columns="columns"
        :data-source="datasource"
        :bordered="true"
        :pagination="pagination"
        @change="tableChange"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'realName'">
            <template v-if="record['viewerType'] === 'JOB_SEEKER'">
              <a-tag color="blue"> 求职者</a-tag>
            </template>
            <template v-if="record['viewerType'] === 'RECRUITER'">
              <a-tag color="green"> 招聘者</a-tag>
            </template>
            {{ record[column.dataIndex] || "未完善信息用户" }}
          </template>

          <template v-if="column.dataIndex === 'targetName'">
            <template v-if="record['targetType'] === 'JOB_SEEKER'">
              <a-tag color="blue"> 求职者</a-tag>
              {{ record["targetRealName"] || "未完善信息用户" }}
            </template>
            <template v-if="record['targetType'] === 'JOB'">
              <a-tag color="green">职位</a-tag>
              {{ record["jobTitle"] }}
            </template>
            <template v-if="record['targetType'] === 'COMPANY'">
              <a-tag color="orange">公司</a-tag>
              {{ record["companyName"] }}
            </template>
          </template>

          <template v-if="column.dataIndex === 'action'">
            <a-popconfirm
              title="是否删除该条查看记录"
              @confirm="handleRemove(record)"
            >
              <a type="link">删除</a>
            </a-popconfirm>
          </template>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<style scoped lang="scss"></style>
